import PlusIcon from '@tuhi/components/assets/icons/buttons/plus.svg'
import React, { FC } from 'react'
import styled from 'styled-components'
import { Tag } from './tag'

const Container = styled(Tag)`
    background: ${(p) => p.theme.colors.tertiary.tertiary600};
    border: 1px solid ${(p) => p.theme.colors.tertiary.tertiary600};
`

interface Props {
    onClick: () => void
}

export const AddTag: FC<Props> = ({ onClick }) => {
    return (
        <Container
            onClick={(e) => {
                if (onClick != null) {
                    e.stopPropagation()
                    e.preventDefault()
                    onClick()
                }
            }}
        >
            <PlusIcon />
        </Container>
    )
}
